const selectors = {
  el: '.js-slider:not(.is-initialized)',
  slide: '.js-slider-slide',
  pagination: '.js-slider-pagination',
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  els.forEach(el => {
    el.classList.add('is-initialized');

    const slides = el.querySelectorAll(selectors.slide);
    const pagination = el.querySelector(selectors.pagination);

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const bulletId = entry.target.dataset.bullet;
          const bullet = pagination.querySelector(`#${bulletId}`);

          if (!bullet) return;
          if (entry.isIntersecting) {
            bullet.classList.add('is-active');
          } else {
            bullet.classList.remove('is-active');
          }
        });
      },
      { threshold: 0.55 },
    );

    slides.forEach(slide => {
      const bullet = document.createElement('span');
      bullet.classList.add('o-pagination__bullet');
      pagination.appendChild(bullet);
      bullet.id = `bullet-${Math.random().toString(36).substring(2, 9)}`;
      slide.dataset.bullet = bullet.id;
      observer.observe(slide);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
